import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import { loadFonts } from "./plugins/webfontloader";
import store from "./store/index";
import { createPinia } from "pinia";
import "./assets/main.css";
import "./assets/admin.css";
import VueGtag from "vue-gtag";
import VueApexCharts from "vue3-apexcharts";
import notificationPlugin from "./plugins/notification";

// Remove credentials persisted by older versions, including after logout.
try {
  localStorage.removeItem("savedPassword");
  localStorage.removeItem("googleLoginSuccess");
} catch {
  // The app can still start when browser storage is unavailable.
}

loadFonts();

const app = createApp(App);
const pinia = createPinia();

app.use(vuetify);
app.use(router);
app.use(store);
app.use(pinia);
app.use(VueApexCharts);
app.use(notificationPlugin);

app.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID },
  },
  router
);

app.mount("#app");
